export default {
  "content": "<path fill=\"#707070\" fill-rule=\"evenodd\" d=\"M11.075 9.955a5.908 5.908 0 001.075-3.413C12.15 3.32 9.604.708 6.462.708 3.322.708.775 3.32.775 6.542c0 3.221 2.546 5.833 5.687 5.833 1.305 0 2.507-.45 3.467-1.208l3.873 3.873a.833.833 0 101.179-1.179l-3.906-3.906zM10.9 6.542c0 2.561-2.016 4.583-4.438 4.583-2.42 0-4.437-2.022-4.437-4.583 0-2.562 2.016-4.584 4.437-4.584 2.422 0 4.438 2.022 4.438 4.584z\" clip-rule=\"evenodd\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "16",
    "height": "16",
    "fill": "none",
    "viewBox": "0 0 16 16"
  }
};